import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from './NotifPopup';

//DAFTAR MERK BAN
export function PageKonten5({token}) {
  const [data, setData] = useState([{id: '',nama_merk_ban: ''}]);
  const [nama, setNama] = useState('');
  
  const [sortBy, setSortBy] = useState('nama'); // 'kode' | 'nama'
  const [sortDir, setSortDir] = useState('asc'); // asc | desc
  const [showTambah, setShowTambah] = useState(false); // asc | desc
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({id: '',nama: ''});
  const [showHapus, setShowHapus] = useState(false);
  const [hapusData, setHapusData] = useState({id: '',nama: ''});
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { showNotif } = useNotification();
  
  //PAGINATION
  const loadData = async () => {
    await api.get(
      `${backendPort}/api/master/daftar_merk_ban`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  .then(res => {

    const sortedData = [...res.data].sort((a, b) =>
    a.nama_merk_ban.localeCompare(b.nama_merk_ban)
    );
    setData(sortedData);}
  )
  .catch(err => console.error(err));
  };

  useEffect(() => {
    loadData();
  }, []);

  const filteredData = useMemo(() => {
      return data.filter(item => {
        const searchMatch =
          item.nama_merk_ban.toLowerCase().includes(search?.toLowerCase() ?? '');
        return searchMatch;
      });
    }, [data, search]);

  const PAGE_SIZE_OPTIONS = [5, 10, 20];
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );
  const maxVisible = 5;
  let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
    }
  const visiblePages = [];  
  for (let i = startPage; i <= endPage; i++) {
  visiblePages.push(i);}

  const handleTambah = async (e) => {
    try{
      e.preventDefault();
      setShowTambah(false);
      await api.post(`${backendPort}/api/master/tambah_merk_ban`, {
        nama
      });

      setNama('');
      loadData();
      showNotif('success', 'Data Berhasil Ditambahkan');  
    } catch (err) {
      showNotif('error', 'Penambahan Data Error');
    }
    
  };
  
  const handleEdit = async (e) => {
    try{
      setShowEdit(false);
      e.preventDefault();
      await api.put(
      `${backendPort}/api/master/edit_merk_ban`,
      { id: editData.id, nama: editData.nama }
      );
      console.log(`Berhasil Edit = ${editData.id},${editData.nama}`);
      showNotif('success', 'Update Data Berhasil');
      await loadData();
    }
    catch(e)
    {showNotif('error', 'Update Data Error');}
  };
  
  const handleDelete = async (e) => {
    try{
      if (e) e.preventDefault();
      setShowHapus(false);

      console.log(`Berhasil Delete = ${hapusData.id},${hapusData.nama}`);
      await api.delete(
      `${backendPort}/api/master/delete_merk_ban/${hapusData.id}`
      );
      
      showNotif('success', 'Delete Data Berhasil');
      loadData();
      setHapusData({id: '', nama: ''});
      
    }
    catch(e)
    {showNotif('error', 'Delete Data Error');}
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

const sortedData = [...paginatedData].sort((a, b) => {
  if (!sortBy) return;

    const valA = sortBy === 'kode' ? String(a.id) : a.nama_merk_ban;
    const valB = sortBy === 'kode' ? String(b.id) : b.nama_merk_ban;

    if (sortDir === 'asc') {
      return valA.localeCompare(valB);
    } else {
    return valB.localeCompare(valA);
    }
  });

  return (
    <div className="container-fluid">
      <div className="row">
                {/* TABLE */}
        <div className="col-md-6">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center" style={{ background: "#09314F", color: "#fff"  }}>
            Daftar Merk Ban
            <button className="btn btn-outline-secondary ls" style={{fontSize: "large", color: "#fff"}} 
              onClick={()=>{
                setShowTambah(!showTambah); 
                setShowEdit(false); 
                setShowHapus(false); 
                setNama('');
                }}>Tambah <i className="fa fa-add"></i></button>
            </div>

            <div className="card-body p-0">
              <div className="row my-2 mx-1">
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="Cari..."
                      value={search}
                      onChange={e => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                <div className="col-md-4"></div>
                <div className="col-md-4 text-end">
                  <label className="form-label">Show</label>
                  <select
                    className="form-select w-auto d-inline-block ms-2"
                    value={pageSize}
                    onChange={e => {
                      setPageSize(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    {PAGE_SIZE_OPTIONS.map(x => (
                      <option key={x}>{x}</option>
                    ))}
                  </select>
                </div>
              </div>
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('kode')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Kode</span>
                        {sortBy === 'kode' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th onClick={() => handleSort('nama')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Merk</span>
                        {sortBy === 'nama' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>
                    
                    <th width="80">Aksi</th>
                 
                  </tr>
                </thead>
                <tbody>
                    {sortedData.map((row) => (
                      <tr key={row.id}>
                        <td>{`B-${row.id}`}</td>
                        <td>{row.nama_merk_ban}</td>
                        <td className="d-flex justify-content-between align-items-center">
                          <span onClick={() => {
                              setEditData({id: row.id, nama: row.nama_merk_ban});
                              setShowEdit(!showEdit);
                              setShowTambah(false);
                              setShowHapus(false);
                            }}
                            style={{ cursor: 'pointer' }}>
                            <i className="fa fa-folder-open"></i>
                            </span>

                          <span onClick={async () => {
                              setHapusData({id: row.id, nama: row.nama_merk_ban});
                              setShowHapus(!showHapus);
                              setShowTambah(false);
                              setShowEdit(false);
                            }}
                            style={{ cursor: 'pointer' }}>
                              <i className="fa fa-trash text-red-500"></i>
                              </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/* PAGINATION NAV */}
            <div className="d-flex justify-content-between align-items-center my-2 mx-3">
            <div>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {Math.min(page * pageSize, filteredData.length)} of{" "}
              {filteredData.length} entries
            </div>

            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 && "disabled"}`}>
                  <button
                    className="page-link"
                    onClick={() => setPage(1)}
                  >
                    ←
                  </button>
                </li>

                {visiblePages.map(p => (
                  <li
                    key={p}
                    className={`page-item ${page === p && "active"}`}
                  >
                    <button className="page-link" onClick={() => setPage(p)}>
                      {p}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    page === totalPages && "disabled"
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(totalPages)}
                  >
                    →
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          </div>
        </div>


        {/* FORM TAMBAH*/}
        {showTambah && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff" }}>
              Tambah Merk Ban
            </div>
            <div className="card-body">
              <form onSubmit={handleTambah}>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={nama}
                    onChange={(e) => setNama(e.target.value)}
                  />
                </div>

                <button className="btn btn-primary me-2"
                  disabled={!nama.trim()}
                  >Simpan</button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowTambah(false);
                  }}
                >
                  Batal
                </button>
              </form>
            </div>
          </div>
        </div>}

        {/* FORM Edit*/}
        {showEdit && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff"  }}>
              Edit Merk Ban
            </div>
            <div className="card-body">
              <form onSubmit={handleEdit}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={`B-${editData.id}`}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={editData.nama}
                    onChange={(e) => setEditData({ ...editData, nama: e.target.value })}
                  />
                </div>

                <button className="btn btn-primary me-2">Update</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowEdit(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div>}

        {/* FORM Hapus*/}
        {showHapus && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{ background: "#dc3545", color: "#fff" }}>
              Hapus Merk Ban
            </div>
            <div className="card-body">
              <form onSubmit={handleDelete}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={`B-${hapusData.id}`}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={hapusData.nama}
                    disabled
                  />
                </div>

                <button className="btn btn-danger me-2">Delete</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowHapus(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div>}

      </div>
    </div>
  );
}
